import { FIELD, FIELD_LABEL, INTEGER_FORMAT, PARAMETERS_TITLE } from "./constants";

const TABLE = "WMITEMTASKDETAILS";

/**
 * The one group reproduces the legacy form's bottom-left group box (grpBottomLeft in uWMD0124.dfm),
 * which holds exactly these two question fields. Field order is the DFM's visual and tab order:
 * edtStartDate above edtCalculatedDate.
 *
 * The group box beside it (grpBottomRight) is empty on the Delphi form — it exists only to balance the
 * panel — so nothing is reproduced for it.
 *
 * isLabelChanged: true so Fields.js uses the literal caption rather than a Localization lookup — these
 * must match the Delphi form and no localization keys exist for them.
 *
 * required:
 *  - Start Date IS required, a deliberate narrowing of AI8. btnPreviewClick clears the query parameter
 *    when the question is null, which makes every comparison in the WHERE unknown and the grid empty —
 *    indistinguishable, to the user, from "nothing qualifies". The server requires it too.
 *  - Number Days is required: false because 0 is both legitimate and the default, and a static
 *    RequiredRule on a numeric rejects 0 in some Fields.js paths. The real rule is "zero or more",
 *    enforced in the page's validate() and again server-side in ValidateRequest.
 *
 * `format` is honoured by Fields.js for type "number" only, which is what Number Days is. There is no
 * min/max passthrough, which is why the lower bound lives in the page and the service.
 */
const ParametersLayout = [
    {
        groupId: 1,
        label: PARAMETERS_TITLE,
        fields: [
            {
                name: FIELD.StartDate,
                tableName: TABLE,
                label: FIELD_LABEL.StartDate,
                type: "date",
                required: true,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.NumberOfDays,
                tableName: TABLE,
                label: FIELD_LABEL.NumberOfDays,
                type: "number",
                format: INTEGER_FORMAT,
                required: false,
                visible: true,
                isLabelChanged: true,
            },
        ],
    },
];

export { ParametersLayout };
